<template>
  <div>
    <Headersys />
    <div class="content">
      <!-- <div class="content-box">
        <div class="btn" @click="printQrcode">
          <img class="img-logo" src="@/assets/images/dzyyzz.png" alt="">
          小程序扫描
        </div>
      </div> -->
      <!-- <div class="content-box">
        <div class="btn" @click="printlerep">
          <img class="img-logo" src="@/assets/images/file.png" alt="">
          法人身份证
        </div>
      </div>
      <div class="content-box">
        <div class="btn" @click="userCerno">
          <img class="img-logo" src="@/assets/images/file.png" alt="">
          输入身份证
        </div>
      </div> -->
      <!-- <div class="content-box">
        <div class="btn" @click="toLerepYYZZ">
          <img class="img-logo" src="@/assets/logosWhite/身份证查询.png" alt="">
          法人身份证
        </div>
      </div> -->
      <div class="yyzz-content">
        为深入推进电子营业执照推广应用，强化数字赋能，实现经营主体“免证办事”“一码通行”，根据山东省人民政府办公厅《关于开展全面应用数字化电子营业执照改革的实施方案》(鲁政办字〔2024〕168号)相关要求，<span
          class="red">自2025年3月1日起，开展全面应用数字化电子营业执照改革，实现涉企（含各类企业、农民专业合作社、个体工商户，下同）业务以全面应用电子营业执照为主，不用、少用纸质营业执照为辅。</span>现将有关事项公告如下：
      </div>
      <div class="yyzz-content">
        一、不再主动核发纸质营业执照。将以往企业身份证明以纸质营业执照为主要载体的传统模式，替代为以电子营业执照为主要载体的新型模式，<span class="red">对省内企业原则上不再主动核发纸质营业执照。</span>
      </div>
      <div class="yyzz-content">
        二、涉企业务全面应用电子营业执照。在行政许可、政务服务、政府采购、公共服务等涉企业务中，能够通过数据共享、电子营业执照调用等方式查询核验企业信息的，相关政府部门和银行、保险、水电气暖、通信等机构，不再要求企业提供纸质营业执照，切实为企业降成本、增便利。
      </div>
      <div class="yyzz-content">
        三、实行新型亮照形式。企业设立或变更登记后，即时生成电子营业执照。登记机关要指导企业及时下载、领取和应用电子营业执照。<span
          class="red">企业将自行打印的电子营业执照PDF图片或“企业码”置于住所或主要经营场所醒目位置，或通过电子显示屏等途径展示电子营业执照或“企业码”的，均视为履行了相关法律法规规定的亮照义务。</span>
      </div>
      <div class="yyzz-content">
        四、优化监督管理方式。涉企监管部门要及时转变工作理念，提升数字化、智能化监管效能，对企业开展监督检查、行政执法等工作时，通过数据共享、电子营业执照调用或扫描“企业码”等方式获取企业登记基本信息，不得要求企业必须出示纸质营业执照。
      </div>
      <div class="yyzz-content">
        五、提供个性化服务。推动营业执照线上线下数据同源、同步更新，坚持智能服务与传统服务创新并行，保留线下使用纸质营业执照的个性化需求服务。企业办理特殊事务或跨省开展经营活动需要纸质营业执照的，登记机关要提供电子营业执照下载和纸质营业执照打印服务。
      </div>
      <!-- <div style="float: right;padding-right: 40rem;">
        <div class="from">
          奎文区行政审批服务局
        </div>
        <div class="from">
          2025年2月24日
        </div>
      </div> -->
      <div class="submit-btn-zx" @click="printQrcode">
        我已知晓
      </div>
      <!-- <div style="height: 30vh;">
      </div> -->
    </div>
    <Back />
  </div>
</template>
<script>
// import lodop from "@/assets/js/doPrint"

export default {
  name: '',
  data() {
    return {
      //
      waitTime: 290,
      watiTimer: null,
    };
  },
  created() {
    //
  },
  mounted() {
    //
    this.timeDown()
  },
  beforeDestroy() {
    // console.log('清除定时器');
    clearTimeout(this.watiTimer);
  },
  methods: {
    // aaa() {
    //   lodop.yyzzPrint('http://112.243.253.8:8081/cc-api/profile/license/tz/9442ccfa-008c-499e-9f19-fd38132c5418.jpg')
    // },
    //电子营业执照小程序扫码
    printQrcode() {
      this.$router.push('/newYYZZ')
    },
    // 法人身份证
    printlerep() {
      this.$router.push('/lerepYYZZ')
    },
    // 输入身份证
    userCerno() {
      this.$router.push('/cernoYYZZ')
    },
    // 新版本 法人身份证查询营业执照
    toLerepYYZZ() {
      this.$router.push('/YYZZlerep')
    },
    // 倒计时
    timeDown() {
      this.watiTimer = setInterval(() => {
        if (this.waitTime > 1) {
          this.waitTime--
        } else {
          this.waitTime = 290
          clearInterval(this.watiTimer)
          this.$router.replace('/')
        }
      }, 1000);
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  height: calc(100vh - 42rem - 40px);
  padding: 20px;
  background-color: #fff;
  overflow-y: scroll;
  // display: flex;
  // align-items: center;
  // justify-content: space-around;
}

.content::-webkit-scrollbar {
  display: none;
  /* 对于Chrome, Safari和Opera */
}

.content-box {
  width: 33%;
  text-align: center;
  font-size: 15rem;
  line-height: 50rem;
}

.btn {
  display: inline-block;
  background-color: #0099FF;
  color: #fff;
  border-radius: 20px;
  padding: 0px 20px 10px;
  display: flex;
  align-items: center;
}

.img-logo {
  display: block;
  width: 20rem;
  height: 20rem;
  margin-right: 10rem;
}

.yyzz-content {
  font-size: 6rem;
  line-height: 7rem;
  text-indent: 12rem;
  margin-bottom: 1rem;
}

.from {
  font-size: 5rem;
  line-height: 5rem;
  margin-bottom: 3rem;
}

.submit-btn-zx {
  width: 30%;
  // margin: 20px auto 0;
  margin: auto;
  text-align: center;
  background-color: #0099FF;
  color: #fff;
  font-size: 7rem;
  line-height: 7rem;
  border-radius: 10px;
  padding: 20px 0;
}

.submit-btn-zx:active {
  background-color: rgba(87, 173, 173, 0.5);
}

.red {
  color: #ff0000;
  font-weight: bold;
}
</style>